import React from 'react';

import { formatMomentDate } from 'utils/formatters/timezone';

import {
  EntityHistoryResponseType,
  RiskControlEventType,
  RiskControlEventValue,
} from 'utils/api/modules/entities/entities.types';

import HistoryRow from 'components/Entities/EntityHistoryTab/HistoryRow';
import { HistoryParagraph } from 'components/Entities/EntityHistoryTab/utils';

const day = (value: number | null | undefined): string => (value ? formatMomentDate(value) : 'no due date');

const describe = (value: RiskControlEventValue): [string, string] => {
  switch (value.event) {
    case RiskControlEventType.Added: {
      const due = value.dueDate ? `, due ${day(value.dueDate)}` : '';
      return ['added', ` as ${value.status}, owner ${value.owner ?? '-'}${due}`];
    }
    case RiskControlEventType.Removed:
      return ['removed', ' from this risk'];
    case RiskControlEventType.StatusChanged:
      return ['changed', ` from ${value.from} to ${value.to}`];
    case RiskControlEventType.OwnerChanged:
      return ['changed the owner of', ` from ${value.from ?? '-'} to ${value.to ?? '-'}`];
    case RiskControlEventType.DueDateChanged:
      return ['changed the due date of', ` from ${day(value.from)} to ${day(value.to)}`];
    case RiskControlEventType.EvidenceSubmitted: {
      const files = value.files?.length ? ` (${value.files.join(', ')})` : '';
      return ['submitted evidence for', `, now ${value.status ?? 'In place'}${files}`];
    }
  }
};

const RiskControlEventRow = ({ item }: { item: EntityHistoryResponseType }): React.ReactElement => {
  const value = item.current as unknown as RiskControlEventValue;
  const [verb, rest] = describe(value);
  return (
    <HistoryRow item={item}>
      <HistoryParagraph data-testid="history-row-risk-control-event">
        <b>{item.createdBy?.name ?? 'N/A'}</b>
        {` ${verb} `}
        <b>{value.control.name}</b>
        {rest}
      </HistoryParagraph>
    </HistoryRow>
  );
};

export default RiskControlEventRow;
